export default function updateObject(oldObject, updatedProps) {
    return {
      ...oldObject,
      ...updatedProps
    };
  };